// extracted by mini-css-extract-plugin
export default {"chat":"ChatBot_chat__9FTWX","btnContainer":"ChatBot_btnContainer__MNXNK","span":"ChatBot_span__Oi97x"};